import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./Store/store";
import App from "./App";
import axios from 'axios';
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { thunk_reset_user } from './Action/action';
import Swal from "sweetalert2";

axios.interceptors.request.use(function (config) {
  const token = store.getState();

  if (token.isAuthenticated) {

    const decoded = jwtDecode(token.AccessToken);
    const currentTime = Date.now() / 1000;
    if (decoded.exp < currentTime) {
      store.dispatch(thunk_reset_user({}));
      Swal.fire({
        icon: "warning",
        title: "Session Expired",
        text: "Your session has expired. Please login again.",
        confirmButtonText: "Re-Login",
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then(() => {
        window.location.href = "/";
      });

      return Promise.reject("Session expired");
      // window.location.href = "/";
    }
    config.headers.Authorization = `Bearer ${token.AccessToken}`;
  }
  else
    config.headers.Authorization = null;

  return config;
});

const root = ReactDOM.createRoot(document.getElementById("root")); // Use createRoot
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>  {/* Newly added for disabling context menu*/}
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>
);